import { ApolloClient } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { setContext } from 'apollo-link-context'

const httpLink = createHttpLink({
  uri: '/api/graphs'
})

const authLink = setContext((_, { headers }) => {
  const token = sessionStorage.getItem('authToken')
  return {
    headers: {
      ...headers,
      authorization: token ? `${token}` : ''
    }
  }
})

const parseCustomName = (name) => {
  if (!name) {
    return ''
  }

  return name.replace(/[?=]|#|%|\\|\/|&|[.,]|=/g, '')
    .toLowerCase()
    .split(' ')
    .join('_')
}

const cacheKeys = {
  dataIdFromObject: (obj) =>
    `${obj.__typename}_${
      obj.id ||
      obj.rid ||
      parseCustomName(obj.name) ||
      obj.keyword ||
      obj.type ||
      obj.idr ||
      obj.uuid
    }`,
}

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
})

export {
  authLink,
  httpLink,
  cacheKeys,
  client,
}
